import Link from "next/link";
import Image from "next/image";

import type { BlogCategory } from "@/types";
import { sanitizePathSegment } from "@/lib/utils";

type Props = { category: BlogCategory };

export default function CategoryCard({ category: { _id, icon, name, slug } }: Props) {
	const pathSegment = slug ? sanitizePathSegment(slug) || _id : null;
	const href = pathSegment ? `/blogs/categories/${pathSegment}` : { pathname: "/blogs", search: "categoryIds=" + _id };

	return (
		<Link
			href={href}
			className="inline-flex h-10 items-center gap-4 text-xsm2"
		>
			<Image alt="" src={icon} height={56} width={56} aria-hidden className="size-7" />
			{name}
		</Link>
	);
}
